import { START_FULL_PATH } from 'routes/constants';

import { ANALYTICS_SOURCE, LOG_OUT } from './constants';

const isDevelopment = process.env.NODE_ENV === 'development';

const REDIRECT_PATH = `${isDevelopment ? 'http://localhost:3002' : ''}${START_FULL_PATH}`;

export const LOG_OUT_OPTION = {
  analytics: {
    source: ANALYTICS_SOURCE,
    text: LOG_OUT,
  },
  url: `/users/sign_out?redirect_to=${REDIRECT_PATH}`,
  target: '_self',
  text: LOG_OUT,
};
